import { Component } from 'react';
import classnames from 'classnames';
import { sendToGA } from '@/components/util';
import { FAIcon } from '@packages/ui-components';

export default class Reel extends Component<any, any> {
  reel: any;

  constructor(props: any) {
    super(props);
    this.state = {};
    this.scrollHorizontally = this.scrollHorizontally.bind(this);
  }

  scrollHorizontally(e: any) {
    if (this.reel) {
      e = window.event || e;
      const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      this.reel.scrollLeft -= delta * 10; // Multiplied by 40
      e.preventDefault();
    }
  }

  componentDidMount() {
    if (this.reel) {
      this.reel.addEventListener('DOMMouseScroll', this.scrollHorizontally, false);
      this.reel.addEventListener('mousewheel', this.scrollHorizontally, false);
    }
  }

  public render() {
    const { reel, move, reelStep, isBlackBackground = true } = this.props;

    return (
      <div
        id="reel-bar"
        ref={(e: any) => {
          this.reel = e;
        }}
        className={classnames({ white: !isBlackBackground })}
      >
        <div className="scroll-div" style={{ width: `${170 * reel.length}px` }}>
          {reel.map((p: any, i: number) => (
            <div
              key={i}
              onClick={() => {
                move(i);
                sendToGA('event', {
                  eventCategory: 'Highlight',
                  eventAction: 'click',
                  eventLabel: p.name,
                  eventId: p.id,
                });
              }}
              className={reelStep === i ? 'preview active' : 'preview'}
              style={{ backgroundImage: `url(${p.thumbnailUrl})` }}
            >
              {!p.is360 && p.mode === 'mode.inside' && <FAIcon icon="faWalking" />}
              {p.is360 && <img src="/images/panorama.png" alt="panorama-icon" />}
              <span>{p.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
